export default __webpack_public_path__ + "static/media/arrowRight.170bd1d9.svg";